package nl.astraeus.wiki.messages

class UpdatePageTitleMessage() : Message(
  MessageType.UPDATE_PAGE_TITLE,
  MessageHeader.PAGE_ID,
  MessageHeader.PAGE_TITLE,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(wikiId: Long, title: String) : this() {
    setHeader(MessageHeader.PAGE_ID, wikiId.toString())
    setHeader(MessageHeader.PAGE_TITLE, title)
  }

}
